// extracted by mini-css-extract-plugin
export default {"container":"image-grid_container","image1":"image-grid_image1","image2":"image-grid_image2","image3":"image-grid_image3","image4":"image-grid_image4"};